import ADSRNode from './adsrnode';

class Choir {
	constructor(input, context, outNode, envelopeParams, overtones) {
		const lfo = context.createOscillator();
		lfo.type = 'sine';
		lfo.frequency.setValueAtTime(10, context.currentTime);
		lfo.start();
		this.voices = [0, 1, 2, 3, 4, 5, 6].map(
			n => new Voice(input, context, outNode, envelopeParams, n, overtones, lfo)
		);
		this.offness = 0;
	}

	updateEnvelope(envelopeParams) {
		this.voices.forEach(vox => vox.updateEnvelope(envelopeParams));
	}

	setQ = v => {
		this.voices.forEach(vox => vox.setQ(v));
	};

	updateOTGain(idx, value) {
		this.voices.forEach(vox => vox.updateOTGain(idx, value));
	}

	updateHPGain(value) {
		this.voices.forEach(vox => vox.updateHPGain(value));
	}

	setNote = midiNumber => {
		var voiceIdx;
		var min = 1000;
		var minIdx = -1;
		for (var idx = 0; idx < this.voices.length; idx++) {
			if (this.voices[idx].note === null && this.voices[idx].envelope.offset.value < 0.001) {
				voiceIdx = idx;
				break;
			} else {
				var delta = this.voices[idx].envelope.offset.value;
				if (delta < min) {
					min = delta;
					minIdx = idx;
					voiceIdx = minIdx;
				}
			}
		}
		if (this.voices.note !== null) {
			this.voices[voiceIdx].stop();
		}
		this.voices[voiceIdx].setNote(midiNumber, this.offness);
	};

	stopNote = midiNumber => {
		for (var idx = 0; idx < this.voices.length; idx++) {
			if (this.voices[idx].note === midiNumber) {
				this.voices[idx].stop();
				return;
			}
		}
	};

	stopAllNotes = () => {
		this.voices.forEach(v => v.stop);
	};

	modulateNote = (midiNumber, value) => {
		for (var idx = 0; idx < this.voices.length; idx++) {
			if (this.voices[idx].note === midiNumber) {
				this.voices[idx].modulate(value);
				return;
			}
		}
	};
}

class Voice {
	constructor(input, context, outNode, envelopeParams, n, overtones, lfo, defaultQ) {
		this.overtones = overtones;
		this.context = context;

		this.lfoGain = this.context.createGain();
		lfo.connect(this.lfoGain);

		this.gainNode = this.context.createGain();
		this.gainNode.connect(outNode);

		this.qCompensationGain = context.createGain();
		this.qCompensationGain.connect(this.gainNode);

		this.gainNode.gain.value = 0;

		this.note = null;

		this.envelope = ADSRNode(context, {
			base: 0,
			peak: 1,
			attack: envelopeParams.attack, // seconds until hitting 1.0
			decay: envelopeParams.decay, // seconds until hitting sustain value
			sustain: envelopeParams.sustain, // sustain value
			release: envelopeParams.release, // seconds until returning back to 0.0
		});
		this.envelope.start();

		this.envelope.connect(this.gainNode.gain);

		this.filters = this.overtones.map(ot => context.createBiquadFilter());

		this.filters.forEach(f => {
			f.type = 'bandpass';
			input.connect(f);
			f.postGain = context.createGain();
			f.connect(f.postGain);
			f.postGain.connect(this.qCompensationGain);
			this.lfoGain.connect(f.detune);
		});

		this.hp = context.createBiquadFilter();
		this.hp.type = 'highpass';

		this.hp.frequency.setValueAtTime(10000, this.context.currentTime);
		input.connect(this.hp);
		this.hp.postGain = context.createGain();
		this.hp.connect(this.hp.postGain);
		this.hp.postGain.connect(this.qCompensationGain);
		this.lfoGain.connect(this.hp.detune);
		this.hp.postGain.gain.setValueAtTime(0, this.context.currentTime);

		this.stopModulation = () => {
			this.filters.forEach((f, idx) => f.detune.setValueAtTime(0, this.context.currentTime));
			this.hp.detune.setValueAtTime(0, this.context.currentTime);
		};
		this.setModulation = v => {
			this.filters.forEach((f, idx) => f.detune.setValueAtTime(v * 50, this.context.currentTime));
			this.hp.detune.setValueAtTime(v * 50, this.context.currentTime);
		};
	}

	updateEnvelope = envelopeParams => {
		this.stop();
		this.envelope.update(envelopeParams);
	};

	updateOTGain = (idx, value) => {
		this.filters[idx].postGain.gain.setValueAtTime(value, this.context.currentTime);
	};

	updateHPGain = value => {
		this.hp.postGain.gain.setValueAtTime(value, this.context.currentTime);
	};

	modulate = value => {
		this.setModulation(value);
	};

	setQ = v => {
		let newGain = Math.log(v + 1) / 3.7;
		this.qCompensationGain.gain.setValueAtTime(newGain, this.context.currentTime);

		this.filters.forEach((f, i) => {
			f.Q.setValueAtTime(v, this.context.currentTime);
		});
	};

	setNote = (midiNumber, offness) => {
		// this.envelope.reset()
		this.note = midiNumber;
		let baseFreq = Math.pow(2, (midiNumber - 69) / 12) * 440;
		this.filters.forEach((f, idx) => {
			f.frequency.setValueAtTime(
				baseFreq * (1 + (idx !== 0) * (Math.random() - 0.5) * offness) * this.overtones[idx],
				this.context.currentTime
			);
			// this.lfoGain.gain.setValueAtTime(0, this.context.currentTime);
		});
		this.hp.frequency.setValueAtTime(baseFreq * 9, this.context.currentTime);
		this.stopModulation();

		this.envelope.trigger();
	};

	stop = () => {
		if (this.note !== null) {
			this.envelope.release();
			this.note = null;
		}
	};
}

export default Choir;
